// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"ScrollToTop_scrollToTop__8qkKt","icon":"ScrollToTop_icon__S01Wp"};